import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionLinkFragment } from "@/components/items/collection/CollectionLink.fragment"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"
import { VolumeFragment } from "@/components/price/Volume.fragment"

export const FeaturedCollectionSlideFragment = graphql(
  `
    fragment CollectionOverviewFeaturedCollectionSlide on Collection {
      ...CollectionLink
      ...CollectionLockup
      description
      featuredImageUrl
      bannerImageUrl
      imageUrl
      floorPrice {
        pricePerItem {
          ...TokenPrice
        }
      }
      stats {
        volume {
          ...Volume
        }
      }
    }
  `,
  [
    CollectionLinkFragment,
    CollectionLockupFragment,
    TokenPriceFragment,
    VolumeFragment,
  ],
)
